<template>
     <section>
      <div v-for="post in processedPosts">
          <div class="card mb-3">
          <div class="card-header">
          <a :href="post.hostedUrl" target="_blank"><span v-html="post.text"></span></a>
          </div>
            <div class="card-body">

              <div class="card-text">
              <!--  <p v-html="post.createdAt"></p> -->
              <p class="type-info"><span v-html="post.categories.location" ></span> - <span v-html="post.categories.team" ></span> - <span v-html="post.categories.commitment"></span></p>

              <p v-html="post.descriptionPlain" class="text-truncate"></p>
              
              <!-- <p v-html="post.lists"></p> -->
              <a :href="post.applyUrl" target="_blank" >Apply Now</a>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'JobList',
  props: ['jobs','filteredjobs','sortSelected'],
//   data: function () {
//     return {
//       processedPosts: []
//     }
//   },
  computed: {
    processedPosts: function() {
      // console.log('processedPosts');

      if(this.filteredjobs.length>=1){
        var posts = this.filteredjobs;
        // console.log("this.filteredjobs");
      } else {
        var posts = this.jobs;
        // console.log("this.jobs");
      }

      // sort by date: Most recent

      if( this.sortSelected == 'A' ){

        // console.log('this.sortSelected == A');

        posts.sort( ( a, b) => {
          // return new Date(a.date) - new Date(b.date);
          return parseInt( a.createdAt ) < parseInt( b.createdAt ) ? 1 : -1;
        });
      }

      return posts;

      // // Put Array into Chunks to display rows of 4
      // var i, j, chunkedArray = [], chunk = 2;
      // for (i=0, j=0; i < posts.length; i += chunk, j++) {
      //   chunkedArray[j] = posts.slice(i,i+chunk);
      // }
      // //productStore = chunkedArray;
      // //console.log(chunkedArray);
      // return chunkedArray;

    }
  }
}
</script>
